import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, SlidersHorizontalIcon } from 'lucide-react';
import { toast } from 'sonner';
import { schools } from '../data/mockSchools';
import { SchoolCard } from '../components/schools/SchoolCard';
import { FilterSheet, type Filters } from '../components/schools/FilterSheet';
export function Schools() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState<Filters>({});
  const [saved, setSaved] = useState<Set<string>>(new Set());
  const [selected, setSelected] = useState<string[]>([]);
  const [keyword, setKeyword] = useState('');
  const list = useMemo(() => {
    return schools.filter(s => {
      if (keyword && !(s.cn.includes(keyword) || s.en.toLowerCase().includes(keyword.toLowerCase()))) return false;
      const c = filters['国家/地区'];
      if (c?.length && !c.includes(s.country)) return false;
      return true;
    });
  }, [filters, keyword]);
  const toggleSave = (id: string) => {
    const ns = new Set(saved);
    ns.has(id) ? ns.delete(id) : ns.add(id);
    setSaved(ns);
    toast(ns.has(id) ? '已收藏' : '已取消收藏');
  };
  const toggleSelect = (id: string) => {
    if (selected.includes(id)) {
      setSelected(selected.filter(x => x !== id));
    } else {
      if (selected.length >= 3) {
        toast.error('最多选择3所院校');
        return;
      }
      setSelected([...selected, id]);
    }
  };
  const filterCount = Object.values(filters).reduce((n, arr) => n + (arr?.length || 0), 0);
  return <div className="bg-slate-50 min-h-screen pb-28" data-id="element-720">
      {/* Header */}
      <div className="bg-white px-3 pt-3 pb-2 sticky top-0 z-20" data-id="element-721">
        <div className="flex items-center gap-2" data-id="element-722">
          <div className="flex-1 h-9 rounded-full bg-slate-100 flex items-center px-3 gap-2" data-id="element-723">
            <SearchIcon size={14} className="text-slate-400" data-id="element-724" />
            <input value={keyword} onChange={e => setKeyword(e.target.value)} placeholder="搜索院校名称" className="bg-transparent outline-none text-sm flex-1 placeholder-slate-400" aria-label="搜索院校" data-id="element-725" />
          </div>
          <button onClick={() => setOpen(true)} className="flex items-center gap-1 px-3 h-9 rounded-full bg-blue-50 text-blue-600 text-sm font-medium" data-id="element-726">
            <SlidersHorizontalIcon size={14} data-id="element-727" /> 筛选
            {filterCount > 0 && <span className="ml-0.5 bg-blue-600 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center" data-id="element-728">
                {filterCount}
              </span>}
          </button>
        </div>
      </div>

      <div className="px-3 mt-3 space-y-2.5" data-id="element-729">
        {list.map(s => <SchoolCard key={s.id} s={s} saved={saved.has(s.id)} onToggleSave={() => toggleSave(s.id)} selected={selected.includes(s.id)} onToggleSelect={() => toggleSelect(s.id)} data-id="element-730" />)}
        {list.length === 0 && <div className="text-center text-sm text-slate-400 py-12" data-id="element-731">
            没有符合条件的院校
          </div>}
      </div>

      <FilterSheet open={open} onClose={() => setOpen(false)} value={filters} onApply={setFilters} data-id="element-732" />

      {/* Compare bar */}
      {selected.length > 0 && <div className="fixed bottom-14 left-1/2 -translate-x-1/2 w-full max-w-[390px] bg-white border-t border-slate-100 p-3 flex gap-2 z-30" data-id="element-733">
          <button onClick={() => setSelected([])} className="px-4 h-11 rounded-full border border-slate-300 text-slate-700 text-sm" data-id="element-734">
            清空
          </button>
          <button onClick={() => nav(`/compare?ids=${selected.join(',')}`)} className="flex-1 h-11 rounded-full bg-blue-600 text-white font-semibold text-sm" data-id="element-735">
            对比 ({selected.length}/3)
          </button>
        </div>}
    </div>;
}